import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    TsSearchApi,
    TsSearchRequest,
    TsSearchResponse,
    TsVersionsRequest,
    TsVersionsResponse,
} from '../ts-search-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class TsSearchApiImpl extends GuestAwareHttpService implements TsSearchApi {
    async searchTs(request: TsSearchRequest): Promise<TsSearchResponse> {
        const params: Record<string, any> = {
            ts_number: request.ts_number,
        };

        if (request.page) {
            params.page = request.page;
        }
        if (request.page_size) {
            params.page_size = request.page_size;
        }

        const res = await this.getWithGuestSupport<TsSearchResponse>(
            'ts/search',
            params
        );
        return res;
    }

    async getTsVersions(request: TsVersionsRequest): Promise<TsVersionsResponse> {
        const params: Record<string, any> = {
            ts_number: request.ts_number,
        };

        const res = await this.getWithGuestSupport<TsVersionsResponse>(
            'ts/versions',
            params
        );
        return res;
    }
}
